import { ZaiOptionButton } from '@winnin/winnin_ui.components.zai-option-button'

import FadeScrollWrapper from 'components/FadeScrollWrapper'
import { SetupWorkspaceCategory } from 'components/SetupWorkspaceCategory'
import ZaiDataStamp from 'components/ZaiDataStamp'

import type { IZaiChatMobilePage } from './zai-chat-mobile-page.types'

import './zai-chat-mobile-page.styles.scss'

export function ZaiChatMobilePageView({
  questionsList,
  onZaiQuestionClick,
  isLoading,
  error,
  workspaceCategory,
}: IZaiChatMobilePage) {
  return (
    <div className="ZaiChatMobilePageView">
      {!workspaceCategory ? (
        <SetupWorkspaceCategory page="Zai Mobile" />
      ) : (
        <div className="ZaiChatMobilePageView-content">
          <div className="ZaiChatMobilePageView-header">
            <h2 className="ZaiChatMobilePageView-title">Insights by Zai</h2>
          </div>

          <FadeScrollWrapper>
            <div className="ZaiChatMobilePageView-body">
              {questionsList.map(question => (
                <ZaiOptionButton
                  key={question}
                  onQuestionClick={onZaiQuestionClick}
                  question={question}
                  disabled={isLoading || error}
                />
              ))}
            </div>
          </FadeScrollWrapper>

          <div className="ZaiChatMobilePageView-footer">
            <ZaiDataStamp />
          </div>
        </div>
      )}
    </div>
  )
}
